import React from "react";

/**
 * Editorial card — used in both /experiencia (public) and /portal/:token (private).
 * Deliberately understated: thin border, generous padding, subtle hover.
 */
export const ExperienciaCard = ({ icon, label, body, onClick, href, testId }) => {
  const content = (
    <div
      className="group relative flex flex-col h-full bg-white border border-stone-200 hover:border-stone-900 transition-all duration-500 p-8 md:p-10"
      data-testid={testId}
    >
      <div className="flex items-start justify-between mb-8">
        <i className={`fa-solid fa-${icon} text-[22px] text-stone-800 group-hover:text-[#E07A5F] transition-colors duration-500`} />
        <span className="text-[10px] tracking-[0.28em] uppercase text-stone-400 font-medium">
          {"—"}
        </span>
      </div>
      <h3 className="font-serif-display text-2xl md:text-[26px] leading-tight text-stone-900 mb-3">
        {label}
      </h3>
      <p className="text-stone-600 text-[15px] leading-relaxed">
        {body}
      </p>
      <div className="mt-8 flex items-center text-[11px] tracking-[0.32em] uppercase text-stone-500 group-hover:text-stone-900 transition-colors duration-500">
        <span>Explorar</span>
        <i className="fa-solid fa-arrow-right ml-3 text-[10px] group-hover:translate-x-1 transition-transform duration-500" />
      </div>
    </div>
  );

  if (href) {
    return (
      <a href={href} className="block h-full" data-testid={testId}>
        {content}
      </a>
    );
  }
  return (
    <button type="button" onClick={onClick} className="block w-full text-left h-full" data-testid={testId}>
      {content}
    </button>
  );
};

export default ExperienciaCard;
